import { computed, onBeforeUnmount, onMounted, ref } from "vue";
import { clearSession, getStoredUser, getToken } from "../services/api";

const token = ref(getToken());
const user = ref(getStoredUser());

function refresh() {
  token.value = getToken();
  user.value = getStoredUser();
}

export function useSession() {
  refresh();
  onMounted(() => window.addEventListener("magic-session-change", refresh));
  onBeforeUnmount(() => window.removeEventListener("magic-session-change", refresh));
  return {
    token,
    user,
    loggedIn: computed(() => Boolean(token.value)),
    logout: clearSession,
    refresh,
  };
}
